import { Container } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function VisuallyHidden(props) {
  var children = props.children;
  return /*#__PURE__*/jsx(Container, {
    children: children
  });
}

export { VisuallyHidden as default };
